import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
// import { adminMainUrl } from '../../../Config';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
// import Skeleton from 'react-loading-skeleton'
// import Api from '../../../Api';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Select from "react-select";
import Cookies from "js-cookie";
import Api from '../../Api';
import { adminMainUrl } from '../../Config';
import CreateQuoteForm from './modal/CreateQuoteForm';
import EditQuoteForm from './modal/EditQuoteForm';


const GridQueryList = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }
    const GetShipmentType = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/shipment-type/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    shipmentTypeId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setShipmentTypeData(options);
        } catch (error) {
            setShipmentTypeData([]);

            console.error("Error fetching data:", error);
        }
    };
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true)
    const [startDate, setStartDate] = useState(null);
    const [viewData, setViewData] = useState(null)
    const [endDate, setEndDate] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [status_id, setStatus_id] = useState('');
    const [full_name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [origin, setOrigin] = useState('');
    const [destination, setDestination] = useState('');
    const [shipmentType, setShipmentType] = useState('');
    const [shipmentVia, setShipmentVia] = useState('');
    const [pickedBY, setPickedBy] = useState('');
    const [queryList, setQueryList] = useState([]);
    const [id, setId] = useState(null)
    const [isResetting, setIsResetting] = useState(false);
    const fromDate = startDate ? formatDate(startDate) : null;
    const toDate = endDate ? formatDate(endDate) : null;
    const [count, setCount] = useState(1);
    const [shipmentTypeData, setShipmentTypeData] = useState([]);
    const [shipmentViaData, setShipmentViaData] = useState([]);
    const [RequiredServiceId, setRequiredServiceId] = useState([]);
    const [requiredServiceData, setRequiredServiceData] = useState('')
    const [filterTab, setFilterTab] = useState("all")
    const totalPages = queryList?.pagination?.totalPages || 1;

    const scrollContainerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
        setScrollLeft(scrollContainerRef.current.scrollLeft);
    };


    const location = useLocation();
    const quotationId = location ? location?.state ? location?.state?.quotationId : null : null;
    useEffect(() => {
        // Assuming 'quotationId' is part of your state or props
        const hasQuotationId = quotationId; // replace `state` with wherever your state is coming from
        if (hasQuotationId) {
            setFilterTab(`${hasQuotationId}`);
            setCount(1)
        }
        // else {
        //   setFilterTab("all"); setCount(1);
        // }
    }, [quotationId]);


    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollContainerRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Adjust scroll speed here
        scrollContainerRef.current.scrollLeft = scrollLeft - walk;
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCount(pageNumber);
        }
    };
    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxPageNumbersToShow = 5;

        if (totalPages <= maxPageNumbersToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            if (count <= 3) {
                pageNumbers.push(1, 2, 3, 4, '...', totalPages);
            } else if (count > 3 && count < totalPages - 2) {
                pageNumbers.push(1, '...', count - 1, count, count + 1, '...', totalPages);
            } else {
                pageNumbers.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return pageNumbers;
    };

    const pageNumbers = getPageNumbers();
    const fetchQuotations = async (page, size) => {
        setLoading(true)
        try {
            const token = Cookies.get("token");
            const requestBody = {
                search_by: searchText,
                request_no: status_id,
                name: full_name,
                email: email,
                phone: mobileNumber,
                origin: origin,
                destination: destination,
                shipment_type_id: shipmentType,
                shipment_via_id: shipmentVia,
                required_servie_id: requiredServiceData,
                start_date: fromDate,
                end_date: toDate,
                filter_by: filterTab
                // quotation_date:,
                // page: currentPage,
                // pageSize: 10,

            };

            const response = await fetch(`${adminMainUrl}/api/quotation/list?page=${count}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token,
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                setLoading(false);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            setLoading(false);
            const data = await response.json();
            setQueryList(data)
        } catch (error) {
            setLoading(false);
            alert(error)
        } finally {
            setLoading(false);
        }
    };
    const arr = new Array(5).fill(null);
    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const GetShipmentVia = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/shipment-via/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    shipmentViaId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setShipmentViaData(options);
        } catch (error) {
            setShipmentViaData([]);

            console.error("Error fetching data:", error);
        }
    };
    const RequiredService = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/required-service/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    RequiredServiceId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setRequiredServiceId(options);
        } catch (error) {
            setRequiredServiceId([]);

            console.error("Error fetching data:", error);
        }
    };
    useEffect(() => {
        fetchQuotations(filterTab);
    }, [filterTab, count]);

    useEffect(() => {
        GetShipmentType();
        GetShipmentVia();
        RequiredService()
    }, []);
    useEffect(() => {
        if (isResetting) {
            fetchQuotations();
            setIsResetting(false);  // Reset the flag after fetching quotations
        }

    }, [isResetting]);
    const resetFields = () => {
        setSearchText('');
        setStatus_id('');
        setName('');
        setEmail('');
        setMobileNumber('');
        setOrigin('');
        setDestination('');
        setShipmentType("");
        setShipmentVia('');
        setPickedBy('');
        setRequiredServiceData('');
        // setRequiredServiceId([]);
        // setShipmentViaData([]);
        // setShipmentTypeData([]);
        setStartDate(null);
        setEndDate(null);
        setIsResetting(true);
    };
    const handleStartDateChange = (date) => {
        if (date && date.getTime() === endDate?.getTime()) {
            alert("Start date and end date cannot be the same");
            return;
        }
        setStartDate(date);
        if (endDate && date && endDate.getTime() < date.getTime()) {
            setEndDate(null);
        }
    };
    const handleEndDateChange = (date) => {
        if (date && date.getTime() === startDate?.getTime()) {
            Swal.fire('Error', 'Start date and end date cannot be the same', 'error');
            return;
        }
        if (date && startDate && date.getTime() < startDate.getTime()) {
            Swal.fire('Error', 'End date cannot be before the start date', 'error');
            return;
        }
        setEndDate(date);
    };
    const PickedQuotation = async (quotationId) => {
        try {
            const token = Cookies.get("token");
            const requesId = {
                quotation_id: `${quotationId}`,
            };
            const response = await fetch(`${adminMainUrl}/api/quotation/to_be_picked`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                },
                body: JSON.stringify(requesId),
            });
            const data = await response.json();
            if (!response.ok) {
                toast.error(data?.msg);
                // throw new Error(`HTTP error! status: ${response.status}`);
            }
            toast.success(data?.msg);
            navigate('/flexichain/query-information', { state: { quotationId: quotationId } })
        } catch (error) {
            // toast.error(error);
            console.log(error);
        }
    };
    const columns = [
        { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
        { title: "Date", dataIndex: "date", key: "date" },
        { title: "Name", dataIndex: "name", key: "name" },
        { title: "Email", dataIndex: "email", key: "email" },
        { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
        { title: "Origin", dataIndex: "origin", key: "origin" },
        { title: "Destination", dataIndex: "destination", key: "destination" },
        { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
        { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
        { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];
    const dataSource = queryList?.data?.map((value, i) => ({
        key: i, // Add a unique key for each row
        requestNo: value?.request_no, // Changed to camelCase
        date: value?.createdAt, // Ensure date formatting as needed
        name: (
            <h2 className="d-flex align-items-center">
                <Link to="#" className="avatar avatar-sm me-2">
                    <img className="img-fluid" src="/assets/img/profiles/avatar-19.jpg" alt="avatar" />
                </Link>
                <Link to="#" className="d-flex flex-column">
                    <span className="text-default">{value?.full_name}</span>
                </Link>
            </h2>
        ),
        email: value?.email, // Make sure to use the correct data field for email
        phoneNumber: value?.phone, // Correct data field for phone number
        origin: value?.origin, // Correct data field for origin
        destination: value?.destination, // Correct data field for destination
        shipmentType: value?.shipment_type?.name, // Correct field for shipment type
        shipmentVia: value?.shipment_via?.name, // Correct field for shipment via
        pickedBy: value?.picked_by ? value?.picked_by : "-", // Correct field for picked by
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    {/* <Link className="dropdown-item" to="#" onClick={() => {
                        setViewData(value);
                        setId(value?.id)
                    }} data-bs-toggle="offcanvas" data-bs-target="#offcanvas_edit_form">
                        <i className="ti ti-edit text-blue"></i> Edit
                    </Link>
                    <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_contact">
                        <i className="ti ti-trash text-danger"></i> Delete
                    </Link> */}
                    <Link className="dropdown-item" to="#">
                        <i className="ti ti-eye text-blue-light"></i> Preview
                    </Link>
                </div>
            </div>
        ),
    }));
    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="row">
                    <div className="col-md-12">
                        {/* Page Header */}
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">
                                        Total Query<span className="count-title">123</span>
                                    </h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        {/* <a
                                            href="contact-grid.html"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            data-bs-original-title="Refresh"
                                        >
                                            <i className="ti ti-refresh-dot" />
                                        </a> */}
                                        <a
                                            href="javascript:void(0);"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            data-bs-original-title="Collapse"
                                            id="collapse-header"
                                        >
                                            <i className="ti ti-chevrons-up" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Page Header */}
                        {/* Card */}
                        <div className="card">
                            <div className="card-header">
                                {/* Search */}
                                <div className="row align-items-center">
                                    <div className="col-sm-4">
                                        <div className="icon-form mb-3 mb-sm-0">
                                            <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search "
                                                value={searchText}
                                                onChange={(e) => setSearchText(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-8">

                                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                            <a onClick={() => { fetchQuotations() }} className="btn btn-primary me-2">
                                                Search
                                            </a>
                                            <a
                                                className='btn btn-primary me-2'
                                                //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                                                onClick={() => { resetFields() }}
                                            >
                                                Clear
                                            </a>
                                            {/* <div className="dropdown me-2">
                                            <a
                                                href="javascript:void(0);"
                                                className="dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                            >
                                                <i className="ti ti-package-export me-2" />
                                                Export
                                            </a>
                                            <div className="dropdown-menu  dropdown-menu-end">
                                                <ul>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-file-type-pdf text-danger me-1" />
                                                            Export as PDF
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-file-type-xls text-green me-1" />
                                                            Export as Excel{" "}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div> */}
                                            <a
                                                href="javascript:void(0);"
                                                className="btn btn-primary"
                                                data-bs-toggle="offcanvas"
                                                data-bs-target="#offcanvas_create"
                                            >
                                                <i className="ti ti-square-rounded-plus me-2" />
                                                Create Quote
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                {/* /Search */}
                            </div>
                            <div className="card-body">
                                {/* Filter */}
                                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                        <div className="dropdown me-2">
                                            <a
                                                href="javascript:void(0);"
                                                className="dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                            >
                                                <i className="ti ti-sort-ascending-2 me-2" />
                                                Sort{" "}
                                            </a>
                                            <div className="dropdown-menu  dropdown-menu-start">
                                                <ul>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-circle-chevron-right me-1" />
                                                            Ascending
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-circle-chevron-right me-1" />
                                                            Descending
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-circle-chevron-right me-1" />
                                                            Recently Viewed
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-circle-chevron-right me-1" />
                                                            Recently Added
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="icon-form">
                                            <span className="form-icon">
                                                <i className="ti ti-calendar" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control bookingrange"
                                                placeholder=""
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                        {/* <div className="dropdown me-2">
                                            <a
                                                href="javascript:void(0);"
                                                className="btn bg-soft-purple text-purple"
                                                data-bs-toggle="dropdown"
                                                data-bs-auto-close="outside"
                                            >
                                                <i className="ti ti-columns-3 me-2" />
                                                Manage Columns
                                            </a>
                                            <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                                                <h4 className="mb-2 fw-semibold">Want to manage datatables?</h4>
                                                <p className="mb-3">
                                                    Please drag and drop your column to reorder your table and
                                                    enable see option as you want.
                                                </p>
                                                <div className="border-top pt-3">
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                        <p className="mb-0 d-flex align-items-center">
                                                            <i className="ti ti-grip-vertical me-2" />
                                                            Name
                                                        </p>
                                                        <div className="status-toggle">
                                                            <input type="checkbox" id="col-name" className="check" />
                                                            <label htmlFor="col-name" className="checktoggle" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                        <p className="mb-0 d-flex align-items-center">
                                                            <i className="ti ti-grip-vertical me-2" />
                                                            Phone
                                                        </p>
                                                        <div className="status-toggle">
                                                            <input type="checkbox" id="col-phone" className="check" />
                                                            <label htmlFor="col-phone" className="checktoggle" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                        <p className="mb-0 d-flex align-items-center">
                                                            <i className="ti ti-grip-vertical me-2" />
                                                            Email
                                                        </p>
                                                        <div className="status-toggle">
                                                            <input type="checkbox" id="col-email" className="check" />
                                                            <label htmlFor="col-email" className="checktoggle" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                        <p className="mb-0 d-flex align-items-center">
                                                            <i className="ti ti-grip-vertical me-2" />
                                                            Tags
                                                        </p>
                                                        <div className="status-toggle">
                                                            <input type="checkbox" id="col-tag" className="check" />
                                                            <label htmlFor="col-tag" className="checktoggle" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                        <p className="mb-0 d-flex align-items-center">
                                                            <i className="ti ti-grip-vertical me-2" />
                                                            Location
                                                        </p>
                                                        <div className="status-toggle">
                                                            <input type="checkbox" id="col-loc" className="check" />
                                                            <label htmlFor="col-loc" className="checktoggle" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                        <p className="mb-0 d-flex align-items-center">
                                                            <i className="ti ti-grip-vertical me-2" />
                                                            Rating
                                                        </p>
                                                        <div className="status-toggle">
                                                            <input type="checkbox" id="col-rate" className="check" />
                                                            <label htmlFor="col-rate" className="checktoggle" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                        <p className="mb-0 d-flex align-items-center">
                                                            <i className="ti ti-grip-vertical me-2" />
                                                            Owner
                                                        </p>
                                                        <div className="status-toggle">
                                                            <input type="checkbox" id="col-owner" className="check" />
                                                            <label htmlFor="col-owner" className="checktoggle" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                        <p className="mb-0 d-flex align-items-center">
                                                            <i className="ti ti-grip-vertical me-2" />
                                                            Contact
                                                        </p>
                                                        <div className="status-toggle">
                                                            <input
                                                                type="checkbox"
                                                                id="col-contact"
                                                                className="check"
                                                                defaultChecked=""
                                                            />
                                                            <label htmlFor="col-contact" className="checktoggle" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                        <p className="mb-0 d-flex align-items-center">
                                                            <i className="ti ti-grip-vertical me-2" />
                                                            Status
                                                        </p>
                                                        <div className="status-toggle">
                                                            <input
                                                                type="checkbox"
                                                                id="col-status"
                                                                className="check"
                                                            />
                                                            <label htmlFor="col-status" className="checktoggle" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <p className="mb-0 d-flex align-items-center">
                                                            <i className="ti ti-grip-vertical me-2" />
                                                            Action
                                                        </p>
                                                        <div className="status-toggle">
                                                            <input
                                                                type="checkbox"
                                                                id="col-action"
                                                                className="check"
                                                            />
                                                            <label htmlFor="col-action" className="checktoggle" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="form-sorts dropdown me-2">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="dropdown"
                                                data-bs-auto-close="outside"
                                            >
                                                <i className="ti ti-filter-share" />
                                                Filter
                                            </a>
                                            <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                                                <div className="filter-set-view">
                                                    <div className="filter-set-head">
                                                        <h4>
                                                            <i className="ti ti-filter-share" />
                                                            Filter
                                                        </h4>
                                                    </div>
                                                    <table className="content-table">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">REQUEST NO.</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Request No."
                                                                        value={status_id}
                                                                        onChange={(e) => setStatus_id(e.target.value)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            {/* <tr>
                                    <td>
                                      <label htmlFor="#">DATE </label>
                                    </td>
                                    <td className="input_box_filter">
                                      {" "}
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Date"
                                      />
                                    </td>
                                  </tr> */}
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">NAME</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Name"
                                                                        value={full_name}
                                                                        onChange={(e) => setName(e.target.value)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">EMAIL</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Email"
                                                                        value={email}
                                                                        onChange={(e) => setEmail(e.target.value)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">PHONE NUMBER</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Number"
                                                                        value={mobileNumber}
                                                                        onChange={(e) => setMobileNumber(e.target.value)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">ORIGIN</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Origin"
                                                                        value={origin}
                                                                        onChange={(e) => setOrigin(e.target.value)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">DESTINATION</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Destination"
                                                                        value={destination}
                                                                        onChange={(e) => setDestination(e.target.value)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">SHIPMENT TYPE</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    <Select
                                                                        options={shipmentTypeData}

                                                                        onChange={(selectedOption) => setShipmentType(selectedOption.shipmentTypeId)}
                                                                    />
                                                                    {/* {" "}
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Shipment Type"
                                        value={shipmentType}
                                        onChange={(e) => setShipmentType(e.target.value)}
                                      /> */}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">SHIPMENT VIA</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    <Select
                                                                        options={shipmentViaData}
                                                                        onChange={(selectedOption) => setShipmentVia(selectedOption.shipmentViaId)}
                                                                    />
                                                                    {/* {" "}
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Shipment Via"
                                        value={shipmentVia}
                                        onChange={(e) => setShipmentVia(e.target.value)}
                                      /> */}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">REQUIRED SERVICE</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    <Select
                                                                        options={RequiredServiceId}
                                                                        onChange={(selectedOption) => setRequiredServiceData(selectedOption.RequiredServiceId)}
                                                                    />
                                                                    {/* {" "}
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Required Service"
                                      /> */}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">PICKED BY</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Picked By"
                                                                        value={pickedBY}
                                                                        onChange={(e) => setPickedBy(e.target.value)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <div className="filter-reset-btns">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <a onClick={() => { resetFields() }} className="btn btn-light">
                                                                    Reset
                                                                </a>
                                                            </div>
                                                            <div className="col-6">
                                                                <a onClick={() => {
                                                                    fetchQuotations();
                                                                    // const dropdownElement = document.getElementById('dropdownMenuLink');
                                                                    // const bootstrapDropdown = new window.bootstrap.Dropdown(dropdownElement);
                                                                    // bootstrapDropdown.hide();
                                                                }} className="btn btn-primary">
                                                                    Filter
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="view-icons">
                                            <Link to={-1} >
                                                <i className="ti ti-list-tree" />
                                            </Link>
                                            <Link to="/flexichain/grid-query-list" className="active">
                                                <i className="ti ti-grid-dots" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {/* /Filter */}
                                {/* Contact List */}
                                <div className='' style={{ width: "auto", overflowX: "auto", overflowY: "hidden", scrollBehavior: "smooth" }}>

                                    <ul className="nav mx-1 nav-pills nav-slider my-2 border-2 custom-tabs" id="pills-tab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => {
                                                setFilterTab("all");

                                            }} className={`nav-link fw-semibold custom-tab  ${filterTab == "all" && 'active'} position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">New <span className="tab-count">{queryList?.getCount?.new}</span></button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => { setFilterTab("2"); setCount(1) }} className={`nav-link ${filterTab == "2" && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Picked <span className="tab-count">{queryList?.getCount?.picked}</span></button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => { setFilterTab("3"); setCount(1) }} className={`nav-link ${filterTab == "3" && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Send For Pricing <span className="tab-count">{queryList?.getCount?.send_for_pricing}</span></button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => { setFilterTab("4"); setCount(1) }} className={`nav-link ${filterTab == "4" && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Price Received <span className="tab-count">{queryList?.getCount?.price_received}</span></button>
                                        </li>

                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => { setFilterTab("5"); setCount(1) }} className={`nav-link ${filterTab == "5" && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Price Viewed <span className="tab-count">{queryList?.getCount?.price_viewed}</span></button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => { setFilterTab("9"); setCount(1) }} className={`nav-link ${filterTab == "9" && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Repricing <span className="tab-count">{queryList?.getCount?.repricing}</span></button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => { setFilterTab("6"); setCount(1) }} className={`nav-link ${filterTab == "6" && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Quotation Sent <span className="tab-count">{queryList?.getCount?.quotation_sent}</span></button>
                                        </li>

                                        {/* <li className="nav-item" role="presentation">
<button className="nav-link fw-semibold custom-tab  position-relative" id="pills-client-tab" data-bs-toggle="pill" data-bs-target="#pills-client" type="button" role="tab" aria-controls="pills-client" aria-selected="false">Client Review</button>
</li> */}
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => { setFilterTab("7"); setCount(1) }} className={`nav-link ${filterTab == "7" && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Converted <span className="tab-count">{queryList?.getCount?.new}</span></button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => { setFilterTab("8"); setCount(1) }} className={`nav-link ${filterTab == "8" && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Not Converted <span className="tab-count">{queryList?.getCount?.new}</span></button>
                                        </li>

                                    </ul>
                                </div>
                                {/* Contact Grid */}
                                <div className="row">
                                    {
                                        queryList?.data?.map((value, i) => {
                                            return (
                                                <div key={i} className="col-xxl-3 col-xl-4 col-md-6">
                                                    <div className="card border">
                                                        <div className="card-body">
                                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                                <div className="d-flex align-items-center">
                                                                    <a
                                                                        href="contact-details.html"
                                                                        className="avatar avatar-md flex-shrink-0 me-2"
                                                                    >
                                                                        <img
                                                                            src="/assets/img/profiles/avatar-19.jpg"
                                                                            alt="img"
                                                                        />
                                                                    </a>
                                                                    <div>
                                                                        <h6>
                                                                            <a
                                                                                href="contact-details.html"
                                                                                className="fw-medium"
                                                                            >
                                                                                {value?.full_name}
                                                                            </a>
                                                                        </h6>
                                                                        <p className="text-default">{value?.origin}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="dropdown table-action">
                                                                    <a
                                                                        href="#"
                                                                        className="action-icon "
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <i className="fa fa-ellipsis-v" />
                                                                    </a>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" onClick={() => {
                                                                            setViewData(value);
                                                                            setId(value?.id)
                                                                        }} data-bs-toggle="offcanvas" data-bs-target="#offcanvas_edit_form">
                                                                            <i className="ti ti-edit text-blue"></i> Edit
                                                                        </Link>
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_contact">
                                                                            <i className="ti ti-trash text-danger"></i> Delete
                                                                        </Link>
                                                                        <Link className="dropdown-item" to="#">
                                                                            <i className="ti ti-eye text-blue-light"></i> Preview
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-block">
                                                                <div className="d-flex flex-column mb-3">
                                                                    <p className="text-default d-inline-flex align-items-center mb-2">
                                                                        <i className="ti ti-mail text-dark me-1" />
                                                                        {value?.email}
                                                                    </p>
                                                                    <p className="text-default d-inline-flex align-items-center mb-2">
                                                                        <i className="ti ti-phone text-dark me-1" />
                                                                        {value?.phone}
                                                                    </p>
                                                                    <p className="text-default d-inline-flex align-items-center">
                                                                        <i className="ti ti-map-pin-pin text-dark me-1" />
                                                                        {value?.destination}
                                                                    </p>
                                                                </div>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="badge badge-tag badge-success-light me-2">
                                                                        {value?.quote_status?.name}
                                                                    </span>
                                                                    {/* <span className="badge badge-tag badge-warning-light">
                                                                        Rated
                                                                    </span> */}
                                                                </div>
                                                            </div>
                                                            {/* <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                                                                <div className="d-flex align-items-center grid-social-links">
                                                                    <a
                                                                        href="#"
                                                                        className="avatar avatar-xs text-dark rounded-circle me-1"
                                                                    >
                                                                        <i className="ti ti-mail fs-14" />
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        className="avatar avatar-xs text-dark rounded-circle me-1"
                                                                    >
                                                                        <i className="ti ti-phone-check fs-14" />
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        className="avatar avatar-xs text-dark rounded-circle me-1"
                                                                    >
                                                                        <i className="ti ti-message-circle-share fs-14" />
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        className="avatar avatar-xs text-dark rounded-circle me-1"
                                                                    >
                                                                        <i className="ti ti-brand-skype fs-14" />
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        className="avatar avatar-xs text-dark rounded-circle"
                                                                    >
                                                                        <i className="ti ti-brand-facebook fs-14" />
                                                                    </a>
                                                                </div>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="set-star text-default me-2">
                                                                        <i className="fa fa-star filled me-1" />
                                                                        4.2
                                                                    </div>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        className="avatar avatar-md"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-original-title="Mervin"
                                                                        data-bs-placement="top"
                                                                    >
                                                                        <img
                                                                            src="/assets/img/profiles/avatar-14.jpg"
                                                                            alt="img"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                                {/* /Contact Grid */}
                                {/* <div className="load-btn text-center">
                                    <a href="javascript:void(0);" className="btn btn-primary">
                                        Load More Contacts
                                        <i className="ti ti-loader" />
                                    </a>
                                </div> */}
                            </div>
                        </div>
                        {/* /Card */}
                    </div>
                </div>
            </div>
            <CreateQuoteForm fetchQuotations={fetchQuotations} id="offcanvas_create" />

            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} />
        </div>


    )
}

export default GridQueryList